module.exports = __webpack_public_path__ + "static/media/1、张家口市政府债务化解和投融资规划-min.187c98a4.png";